import useApi from '../../api/backendApiContext';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import { useQuery } from '@tanstack/react-query';
import { ReactQueryConstants } from '../../commons/constants';
import React from 'react';
import { QueryStatus } from '../../commons/components/QueryStatus';

export const useFetchedCanRevertCanceledSubscription = (props?: {
  refetchOnWindowFocus?: boolean | 'always';
}) => {
  const { billingApi } = useApi();
  const queryCacheManager = useQueryCacheManager();
  const queryKey = queryCacheManager.getCanRevertCanceledSubscriptionCacheKey();
  const query = useQuery(queryKey, async () => billingApi.canRevertCanceledSubscription(), {
    staleTime: ReactQueryConstants.billingStaleTime,
    refetchInterval: ReactQueryConstants.billingRefetchTime,
    refetchOnWindowFocus: props?.refetchOnWindowFocus,
  });

  const queryStatusComponent = (
    <QueryStatus
      queryKey={queryKey}
      queryStatus={query.status}
      dataTestPrefix="can-revert-canceled-subscription"
      failedToLoadText="Something went wrong. Try reloading the page several times. If the issue persists, contact support@growegy.com"
    />
  );

  return { query, queryStatusComponent };
};
